module.exports = __webpack_public_path__ + "img/wp-new-habit-card13.2bd9dd61.jpg";